import Vue from "vue";

Vue.component("notification-forum", {
	props: ["countryId",
		"domain",
		"showForum",
		"hasNationalForum",
		"notificationId",
		"selectedNotificationId",
		"isShowAsIcon",
		"isOpenThroughLink",
		"searchUrl",
		"forumCountryId"
	],
	data() {
		return {
			hasForum: false,
			notificationHasForum: false,
			loadingText: window.labels.loading,
			linkToForumLabel: htmlEntity.decode(window.labels.linkToForum),
			forumLabel: htmlEntity.decode(window.labels.forum),
			urlLink: this.searchUrl ? this.searchUrl + "?notificationId=" + this.notificationId + "&openForum=1" : ''
		};
	},
	methods: {
		checkHasForum: function () {
			this.$services.forumSettings.checkCountryHasForum({
				// countryId: this.countryId,
				// domain: this.domain
				notificationId: this.notificationId
			})
				.then((data) => {
					this.hasForum = data;
					this.$emit("update:hasNationalForum", data);
					this.$emit("update:showForum", true);
					this.$emit("update:selectedNotificationId", this.notificationId);
					this.$emit("update:forumCountryId", this.countryId);
				});
		},
		handleNotificationHasForum: function () {
			this.$services.notifications.hasForum({
				notificationId: this.notificationId
				})
				.then((data) => {
					this.notificationHasForum = data;
				});
		},
		openNotificationForum: function () {
			this.checkHasForum();
		},
		showForumThroughLink: function () {
			window.history.pushState({}, '', this.urlLink);
			this.$emit("update:isOpenThroughLink", true);
		}
	},
	mounted: function () {
		this.handleNotificationHasForum();
	},
	template: `
		<div class="favorite-notification" v-if="isShowAsIcon"> 
			<b-tooltip :label="forumLabel" type="is-primary is-light" position="is-bottom" size="is-small" multilined>
				<b-button @click="openNotificationForum"><b-icon icon="comments" size="is-medium" :type="notificationHasForum ? 'is-success' : 'is-grey'"></b-icon></b-button>
			</b-tooltip>
		</div>
		<div v-else class="column is-full pt-0 pb-1 pl-0">
			<strong>{{ forumLabel }}</strong>:
			<a href="javascript:void(0);" @click="showForumThroughLink">{{ linkToForumLabel }}</a>
		</div>
	`
});